// import { useContext, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram, faDiscord } from '@fortawesome/free-brands-svg-icons';

import { DISCORD_LINK, TELEGRAM_GROUP_LINK, TWITTER_LINK } from 'const';
import 'pages/styles.scss';
import './social.scss';
import Metadata from 'components/Metadata'

function Social() {
  return (
    <>
      <Metadata title="Social Media links" link="/social" description="DogeBets. Social Media links" />
      <div className="flex h-xscreen align-middle justify-center items-center h-auto py-28 md:py-48">
        <div className="container mx-auto">
          <div className='SocialsInnerContainer'>
            <h3 className="text-center text-white font-bold">
              Get in Touch With Us!
            </h3>
            <div className='Socials' >
              <a className='Item Telegram' href={TELEGRAM_GROUP_LINK}>
                <FontAwesomeIcon icon={faTelegram} size='3x' />
                <span>Telegram</span>
              </a>
              <a className='Item Twitter' href={TWITTER_LINK}>
                <FontAwesomeIcon icon={faTwitter} size='3x' />
                <span>
                  Twitter
                </span>
              </a>
              <a className='Item Discord' href={DISCORD_LINK}>
                <FontAwesomeIcon icon={faDiscord} size='3x' />
                <span>Discord</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Social;
